module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-popover', {
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    },
    on: {
      "submit": _vm.submit
    }
  }, [_c('div', [_c('label', {
    staticClass: "form-popover__label",
    attrs: {
      "tabindex": "1"
    }
  }, [_vm._v(_vm._s(_vm.formLabel))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueInput),
      expression: "valueInput"
    }],
    staticClass: "form-popover__input",
    attrs: {
      "autofocus": "",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.valueInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueInput = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d437d642"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/forms/InputFormPopover.vue
// module id = 1994
// module chunks = 0